import { gql, useQuery } from '@apollo/client'
import { toPattern } from 'vanilla-masker'
import { getIsSessionExpired } from '../../../common/utils/is-session-expired.js'

const PARTNER_QUERY = gql`
  query UsePartner {
    account {
      id
      partner {
        id
        name
        loginURL
        logoURL
        customerSupportEmail
        customerSupportPhone
      }
    }
  }
`

export const usePartner = () => {
  const isSessionExpired = getIsSessionExpired()
  const resp = useQuery(PARTNER_QUERY, {
    skip: isSessionExpired,
  })

  const { partner = {} } = resp?.data?.account ?? {}
  const { name: partnerName = '', logoURL, customerSupportPhone = '1-855-387-1314' } = partner
  const isPartnerByName = (nameToVerify) => partnerName.toLowerCase().includes(nameToVerify)
  const isPartnerClover = isPartnerByName('clover')
  const isPartnerSeek = isPartnerByName('seek')
  const isPartnerCreditSuite = isPartnerByName('credit suite')
  const isPartnerCreditSafe = isPartnerByName('creditsafe')
  const navLogoURL = 'https://design-assets.nav.com/logos/nav-logo-purple.svg'
  return {
    ...resp, // Provide all the other Apollo things
    ...partner,
    getIsPartnerCreditSafe: () => isPartnerCreditSafe,
    getIsPartnerClover: () => isPartnerClover,
    getIsPartnerSeek: () => isPartnerSeek,
    getIsPartnerCreditSuite: () => isPartnerCreditSuite,
    getFormattedCustomerSupportPhone: () => toPattern(customerSupportPhone, '+1 (999) 999-9999'),
    getLogoURL: () => logoURL ?? navLogoURL,
  }
}
